module.exports = __webpack_public_path__ + "static/media/silkycloud-gold-3.0be3b5fc.png";